// src/components/HamburgerNav.js
import React, { useState, useEffect, useRef } from 'react';
import './HamburgerNav.css';

const HamburgerNav = ({ animationDelay = '0.4s' }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <nav className="hamburger-nav" style={{ animationDelay }} ref={navRef}>
      <div className={`hamburger ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
        <a href="/go" className="nav-link">Travel Passes</a>
        <a href="/learn-more" className="nav-link">What We Do</a>
        <a href="/origin-story" className="nav-link">Who We Are</a>
        <a href="/back-the-pass" className="nav-link">Back the Pass</a>
      </div>
    </nav>
  );
};

export default HamburgerNav;